type ModelConstructor<T extends object> = new (data: T) => T;
type ModelDefaults<T extends object> = Partial<T> | (() => Partial<T>);

export function modelOf<T extends object>(
  defaults?: ModelDefaults<T>,
): ModelConstructor<T> {
  return class {
    constructor(data: T) {
      const defaultValues =
        typeof defaults === "function" ? defaults() : defaults;

      Object.assign(this, defaultValues, data);
    }
  } as ModelConstructor<T>;
}
